import { render } from "./TransactionDetailComponent.vue?vue&type=template&id=d82ff046"
import script from "./TransactionDetailComponent.vue?vue&type=script&lang=js"
export * from "./TransactionDetailComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__